module.exports = __webpack_public_path__ + "img/death.61e9fa9c.jpg";